window.e3ds = {
    // list of event listeners
    events: {},
    onEvent(eventName, callback) {
        this.events[eventName] = callback;
    },
};

function HandleResponseFromUE4(jsonObj) {
    //process whatever u want to do with your object
    if (window.e3ds.events[jsonObj.cmd]) {
        window.e3ds.events[jsonObj.cmd](jsonObj); //raises the event named by first field of descriptor object
    }
}

//listens for raw message and if of correct format, forwards to eagle3dstreaming's Server   to Iframe communication
const eventHandlerLance = (event) => {
    console.log('Message From webrtc -->  ', event);
    if (!event.data) {
        // if event has .data then it came from windows so skip it
        const parsedData = JSON.parse(event);
        if (parsedData.cmd && parsedData.type) {
            //than is from ue4 following our message format
            console.log('Message From UE4-- >  :', parsedData);
            window.postMessage(parsedData, window.location.origin);
            HandleResponseFromUE4(parsedData); //process the data sent by ue4
        }
    }
};

//addResponseEventListener('webrtcmessage', eventHandlerLance);

function sendToStreamer(obj) {
    emitUIInteraction(obj); //do not stringify. Send json
}
